module.exports = __webpack_public_path__ + "img/carshina21_05.3f92eda4.jpg";